<template>
  <v-row no-gutters class="pt-5">
    <v-col class="pr-2">
      <card-title-row translation-path="sidebar.modelingCurves">
        <template #buttons>
          <base-rounded-button
            icon="mdi-plus"
            size="x-small"
            color="success"
            :tooltip="$i18n.t('button.addCurve')"
            @click="addCurve"
          />
        </template>
      </card-title-row>
      <sidebar-row>
        <modeling-curves-list
          :curves="curves"
          @editCurve="openCurveDialog"
          @deleteCurve="handleDelete"
          class="pt-4"
        ></modeling-curves-list>
      </sidebar-row>
    </v-col>
    <modeling-curve-dialog
      v-if="isCurveDialogLoaded"
      :is-visible.sync="isCurveDialogVisible"
      :curve="editingCurve"
      @modalClosed="resetData"
    ></modeling-curve-dialog>
  </v-row>
</template>

<script>
import CardTitleRow from '@/components/CardTitleRow';
import ModelingCurvesList from '@/components/ModelingCurvesList';
import { call, get } from 'vuex-pathify';
import SidebarRow from '@/components/SidebarRow';

export default {
  name: 'ModelingCurves',
  components: {
    SidebarRow,
    ModelingCurveDialog: () => import('@/components/ModelingCurveDialog'),
    ModelingCurvesList,
    CardTitleRow,
  },
  data: () => ({
    isCurveDialogLoaded: false,
    isCurveDialogVisible: false,
    editingCurve: undefined,
  }),

  computed: {
    curves: get('epanet/curves'),
  },
  methods: {
    getCurves: call('epanet/getCurves'),
    deleteCurve: call('epanet/deleteCurve'),
    addCurve() {
      this.isCurveDialogLoaded = true;
      this.isCurveDialogVisible = true;
      this.editingCurve = {
        name: '',
        description: '',
        curve_type: '',
        data: [],
      };
    },
    async handleDelete(curve_id) {
      await this.deleteCurve(curve_id);
    },
    openCurveDialog(c) {
      this.isCurveDialogLoaded = true;
      this.isCurveDialogVisible = true;
      this.editingCurve = c;
    },
    resetData() {
      this.editingCurve = undefined;
      this.isCurveDialogLoaded = false;
      this.isCurveDialogVisible = false;
    },
    async init() {
      await this.getCurves();
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style scoped></style>
